import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { formatPrice } from "../mobileUtils";

export default function MobilePropertyCard({ property, horizontal = false, listing = false, priority = false }) {
  const location = useLocation();
  const rawLink = property.link || "/stays";
  const link = location.search && rawLink && !rawLink.includes("?") ? `${rawLink}${location.search}` : rawLink;
  const badge = property.badge || property.tag || "";
  return (
    <Link className={`hv-card hv-property-card ${listing ? "hv-property-card-listing" : ""}`} to={link}>
      <div className="hv-property-media">
        <img
          src={property.image}
          alt={property.title}
          loading={priority ? "eager" : "lazy"}
          decoding="async"
          fetchPriority={priority ? "high" : "auto"}
        />
        {badge ? <span className="hv-property-badge">{badge}</span> : null}<span className="hv-property-heart"><i className="bi bi-heart" /></span>
      </div>
      <div className="hv-property-body">
        <div className="hv-property-meta">
          <i className="bi bi-geo-alt" aria-hidden="true" /> {property.location}
        </div>
        <h3 className="hv-property-title">{property.title}</h3>
        <div className="hv-muted-row">
          {property.bedrooms ? `${property.bedrooms} bedrooms` : "Villa"}
          {property.guests ? ` | ${property.guests} guests` : ""}
          {property.rating ? ` | ${Number(property.rating).toFixed(1)} ★` : ""}
        </div>
        <div className="hv-property-bottom">
          <span className="hv-price">{formatPrice(property.price, property.currency)}</span>
          {!listing ? (
            <span className={horizontal ? "hv-secondary-btn" : "hv-primary-btn"} style={{ minHeight: 34, paddingInline: 13 }}>Book</span>
          ) : (
            <small>{property.priceSubtitle || property.priceLabel || "/ night"}</small>
          )}
        </div>
      </div>
    </Link>
  );
}
